import { useCallback, useEffect, useState } from 'react'
import { ApiError, api } from './api'
import { PairingScreen } from './PairingScreen'
import { FocusEditor } from './FocusEditor'

type State = 'loading' | 'paired' | 'unpaired'

export default function App() {
  const [state, setState] = useState<State>('loading')

  const checkSession = useCallback(async () => {
    try {
      await api('/api/session')
      setState('paired')
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) setState('unpaired')
      else if (!navigator.onLine) setState('unpaired')
      else setState('unpaired')
    }
  }, [])

  useEffect(() => {
    void checkSession()
  }, [checkSession])

  if (state === 'loading') {
    return (
      <main className="loading-screen" aria-label="正在打开 FocusNote">
        <img src="/focusnote-icon.svg" alt="" />
      </main>
    )
  }

  if (state === 'unpaired') {
    return <PairingScreen onPaired={() => setState('paired')} />
  }

  return <FocusEditor onUnauthorized={() => setState('unpaired')} />
}
